import React from 'react';
import { useState } from 'react';
import AnimateHeight from 'react-animate-height';

import HTMLRender from '../../../core/components/html-render/html-render';
import Tooltip from '../../../core/components/tooltip/tooltip';
import { useIsMobile } from '../../../core/hooks/use-is-mobile';
import { useLocale } from '../../../core/hooks/use-locale';

import { FaqAccordionItemProps } from './faq-accordion-types';

const ACCORDION_ANIMATION_DURATION = 300;

const FaqAccordionItem: React.FC<FaqAccordionItemProps> = ({
  name,
  content,
  isOpenAll,
}) => {
  const { Message } = useLocale();
  const isMobile = useIsMobile();

  const [isOpen, setIsOpen] = useState(false);

  const classOpen =
    isOpen || isOpenAll
      ? 'faq__perex faq__perex--closed'
      : 'faq__perex faq__perex--opened';

  return (
    <li className="faq__item">
      <Tooltip
        title={isOpen ? `${Message.PACK}` : `${Message.UNPACK}`}
        placement={isMobile ? 'top' : 'right-end'}
      >
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="faq__name"
          aria-expanded={isOpen}
        >
          <span className="faq__name-text">{name}</span>
          <span
            className={`faq__icon ${isOpen || isOpenAll ? '' : 'closed'}`}
          ></span>
        </button>
      </Tooltip>
      {!!content && (
        <p className={classOpen}>
          {typeof content === 'string' && (
            <HTMLRender html={content.convertNbsp().truncate(100)} />
          )}
        </p>
      )}
      <AnimateHeight
        duration={ACCORDION_ANIMATION_DURATION}
        height={isOpen ? 'auto' : 0 || isOpenAll ? 'auto' : 0}
        animateOpacity
      >
        {typeof content === 'string' ? (
          <p className="faq__content">
            <HTMLRender html={content} />
          </p>
        ) : (
          content
        )}
      </AnimateHeight>
    </li>
  );
};

export default FaqAccordionItem;
